module.exports = __webpack_public_path__ + "img/win_8.71a95dd5.png";